const FONT_LOAD_TIMEOUT = 1000;

export async function fontsLoader(fonts, callback) {
  const fontLoadPromises = [];

  if (!fonts.length) return;

  fonts.forEach((font) => {
    const loadPromise = loadFont(font.name, font.style, font.weight);
    fontLoadPromises.push(loadPromise);
  });

  try {
    await Promise.allSettled(fontLoadPromises);
    callback?.();
  } catch (err) {
    console.warn("Some critical font are not available:", err);
  }
}

function loadFont(fontName, fontStyle, fontWeight) {
  return new Promise((resolve, reject) => {
    let intervalId;

    const checkFontLoaded = () => {
      if (document.fonts.check(`${fontStyle} ${fontWeight} 16px ${fontName}`)) {
        clearInterval(intervalId);
        resolve();
      }
    };

    intervalId = setInterval(() => {
      checkFontLoaded();
    }, 100);

    setTimeout(() => {
      clearInterval(intervalId);
      reject(new Error(`Font ${fontName} failed to load within ${FONT_LOAD_TIMEOUT}ms`));
    }, FONT_LOAD_TIMEOUT);
  });
}